import React from 'react';
import { format } from 'react-string-format';
import Pusher from 'pusher-js';
import {withRouter} from "../withRouter";
import * as ReactDOM from "react-dom";
import Game from "../Game";

class ManageGameCategory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isCategoriesLoaded: false,
            categories: [],
            error: null
        };
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({
            isCategoriesLoaded: false
        })

        let body = {};

        if (e.target.create_new ? e.target.create_new.checked : true) {
            body = {
                'game_category': {
                    'name': e.target.new_category_name.value,
                    'description': e.target.new_category_description.value,
                }
            };
        } else {
            body = {
                'game_category_id': e.target.game_category_id.value,
            };
        }

        fetch(format(process.env.REACT_APP_API_URL + '/publisher/game/{0}/update/category', this.props.game.id.toString()), {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then((response) => {
            console.log(response);
            console.log(JSON.stringify(body));
            window.location.reload(false);
        });
    }

    hideOrShowNewCategoryForm(){
        let form = document.getElementById('new_category_data');
        let gameCategoryIdInput = document.getElementById('game_category_id_input');

        if (form.style.display === 'none') {
            form.style.display = 'block';
            gameCategoryIdInput.style.display = 'none';
        } else {
            form.style.display = 'none';
            gameCategoryIdInput.style.display = 'block';
        }
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + "/publisher/company/" + this.props.game.company_id + "/categories", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isCategoriesLoaded: true,
                        categories: result.categories
                    })
                },
                (error) => {
                    this.setState({
                        isCategoriesLoaded: true,
                        error
                    })
                }
            )
    }

    render() {
        const {categories, isCategoriesLoaded} = this.state;

        let categoriesFormatted = null;
        if (isCategoriesLoaded) {
           categoriesFormatted = <ul>
               {categories.map(item => (
                   <li>{item.id} - {item.name}</li>
            ))}
           </ul>
        } else {
            categoriesFormatted = <h4>Loading...</h4>;
        }
            return (
                <div>
                    <h1>Category information</h1>
                    <form onSubmit={this.handleSubmit.bind(this)}>
                        {categories.length > 0 ?
                            <div>
                                <div id="game_category_id_input">
                                    <label>Category: </label>
                                    <select className="form-select" aria-label="Default select example" name="game_category_id">
                                        {categories.map(category =>
                                            <option selected={this.props.game.game_category_id === category.id} key={category.id} value={category.id}>{category.name}</option>
                                        )};
                                    </select>
                                    <br/>
                                </div>
                                <input className="form-check-input" id="create_new" type="checkbox"
                                       defaultChecked={categories.length === 0} name="create_new"
                                       onChange={this.hideOrShowNewCategoryForm.bind(this)}/>
                                <label className="form-check-label" htmlFor="create_new">Create new</label>
                            </div> : <span></span>
                        }

                        <br/>
                        <div style={{
                            display: categories.length > 0 ? "none" : "block"
                        }} id="new_category_data">
                            <h3>New category</h3>

                            <label>Name: </label>
                            <input class="form-control" type="text" name="new_category_name"/>
                            <br/>

                            <label>Description: </label>
                            <input class="form-control" type="text" name="new_category_description"/>
                            <br/>
                        </div>

                        <input class="btn btn-success" type="submit" value="Save"/>
                    </form>
                    <br/>
                    <br/>
                </div>
            );
    }
}

export default withRouter(ManageGameCategory);
